@if (alfredClientOutputService.showCloseButton()) {
  <lib-close-button [confirmClose]="false" />
}

<h1 class="title">Klaar!</h1>
<div class="content" [innerHTML]="step().text"></div>

@if (step().url) {
  <div class="footer">
    <ion-button color="success" (click)="openThankYouUrl()">
      Bekijk resultaten
    </ion-button>
  </div>
} @else {
  <div class="footer">
    <ion-button color="success" (click)="alfredClientOutputService.finish()">
      Sluiten
    </ion-button>
  </div>
}
